import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill";
import { PointagePause } from "./pointage-pause";
import { Vehicule } from "./vehicule";
import { BaseDOM } from "../base.dom";

export class PointageJournalier extends BaseDOM<PointageJournalier> {
    @AutoMap()
    DepartDomicile?: Temporal.PlainDateTime;
    @AutoMap()
    DebutJournee!: Temporal.PlainDateTime;
    @AutoMap()
    FinJournee!: Temporal.PlainDateTime;
    @AutoMap()
    ArriveeDomicile?: Temporal.PlainDateTime;
    @AutoMap(() => [PointagePause])
    PointagePauseList: PointagePause[] = [];
    @AutoMap()
    Vehicule: Vehicule = new Vehicule()


}